import React, { PureComponent } from "react";
import classnames from "classnames";
import {
    Button,
    Icon,
    Input,
    Dropdown,
    Menu,
    Tooltip,
    Loading,
    Radio
} from "@ss/mtd-react";
import { Tag } from "@ss/mtd-react3";
import { GlobalSearchType, GlobalSearchList } from "@/utils/constant/home";
import colorIconNormal from "@/assets/images/global-color-search-normal.png";
import colorIconDisabled from "@/assets/images/global-color-search-disabled.png";
import picIconNormal from "@/assets/images/global-picture-search-normal.png";
import picIconDisabled from "@/assets/images/global-search-picture-disabled.png";
import RecentSearch from "@/components/global-search-component/RecentSearch";
import ColorSearch from "@/components/global-search-component/ColorSearch";
import ImageSearch from "@/components/global-search-component/ImageSearch";
import { IconfontCart } from "@/components/iconfont-cart";
import { SearchHistory } from "@/utils/searchHistory";
import "./style.scss";
import { GlobalColorSearchTypeList } from "@/utils/constant/home";
import qs from "qs";
import { SearchHistoryKeys } from "@/utils/constant/globalSearch";
import { getUserInfo, getIconsInLs } from "@/utils/index";
import {
    Resource_Type_Identifier,
    Resource_Type_Name
} from "@/utils/constant/teamManagement";
import { fetchData, generateId } from "@/utils";
import urls from "@/urls";
import SearchIcon from "@/assets/images/search-icon.svg";

const MenuItem = Menu.Item;

export default class index extends PureComponent {
    constructor(props) {
        super(props);
        const {
            searchSourceType,
            keyword,
            selectColor,
            selectPic,
            sliderOptions,
            defaultSelectedSlider
        } = this.props;
        const activeSourceType =
            GlobalSearchList.find(
                item => item.value === searchSourceType?.value
            ) || GlobalSearchList[0];
        this.state = {
            searchSourceTypeList: GlobalSearchList,
            searchSourceType: activeSourceType,
            searchType: GlobalSearchType.NO_SEARCH,
            keyword: keyword || "",
            selectColor: selectColor || null,
            selectPic: selectPic || "",
            dropdownVisible: false, // 控制下拉框的显示
            searchSuggestions: [], // 搜索联想结果
            sugId: "",
            picUrl: props?.picUrl || "",
            searchPicVisible: false,
            isShowSearchSuggestions: false,
            searchSuggestionsLoading: false,
            searchHistorys: [],
            selectedRadioValue: defaultSelectedSlider
                ? defaultSelectedSlider.value
                : "",
            showCartDrawer: false,
            cartIconCount: 0
        };
        this.searchInputRef = React.createRef();
        this.searchColorRef = React.createRef();
        this.searchPicRef = React.createRef();
        this.searchDropdownRef = React.createRef();
        // 创建 History 实例
        this.history = new SearchHistory();
        // 添加一个用于追踪最新请求标识符的属性
        this.latestRequestToken = null;
    }

    componentDidMount() {
        window.addEventListener &&
            window.addEventListener("click", this.handleDocumentClick, false);
        window.addEventListener &&
            window.addEventListener("click", this.handleOutsideClick, false);
        this.initSearchHistory();
        const { materialType, keyword, hasExtraSpace } = this.props;
        if (String(materialType) === Resource_Type_Identifier.ALL && keyword) {
            // 将搜索关键词添加到历史记录
            this.history.push(keyword.trim());
            this.saveSearchHistory();
            this.initSearchHistory();
        }
        if (hasExtraSpace) {
            this.getCartIconCount();
            window.addEventListener(
                "cartsStorageChange",
                this.getCartIconCount
            );
            // 其他标签页
            window.addEventListener("storage", e => {
                if (e.key === "carts") {
                    this.getCartIconCount();
                }
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener &&
            window.removeEventListener(
                "click",
                this.handleDocumentClick,
                false
            );
        window.removeEventListener &&
            window.removeEventListener("click", this.handleOutsideClick, false);
        // 在组件卸载之前保存历史记录
        this.saveSearchHistory();
        if (this.props.hasExtraSpace) {
            window.removeEventListener(
                "cartsStorageChange",
                this.getCartIconCount
            );
            window.removeEventListener("storage", this.getCartIconCount);
        }
    }

    handleDocumentClick = event => {
        const { searchType } = this.state;
        const target = event.target;
        const inputContainer = this.searchInputRef.current.inputRef.current;
        const colorContainer = this.searchColorRef.current;
        const imageContainer = this.searchPicRef.current;
        if (searchType !== GlobalSearchType.NO_SEARCH) {
            if (
                target === inputContainer ||
                target === colorContainer ||
                target === imageContainer
            ) {
                return;
            } else {
                this.setState({
                    searchType: GlobalSearchType.NO_SEARCH
                });
            }
        }
    };
    // 搜索
    handleSearchKeyword = () => {
        const { searchSourceType, keyword, sugId, picUrl } = this.state;
        const param = {
            searchSourceTypeValue: searchSourceType.value,
            keyword,
            sugId,
            picUrl: !!keyword ? "" : picUrl
        };
        this.setState({
            searchType: GlobalSearchType.NO_SEARCH,
            dropdownVisible: false
        });
        if (
            String(this.props?.materialType) !== Resource_Type_Identifier.ALL &&
            keyword
        ) {
            // 将搜索关键词添加到历史记录
            this.history.push(keyword.trim());
            this.saveSearchHistory();
            this.initSearchHistory();
        }
        // 搜索后重置sugId
        this.setState({ sugId: "" });

        // 如果 searchInputRef 存在，则调用 blur 方法使输入框失去焦点
        if (this.searchInputRef && this.searchInputRef.current) {
            this.searchInputRef.current.blur();
        }
        const { handleSearchKeyword } = this.props;
        handleSearchKeyword(param);
    };

    handlePressEnter = () => {
        this.latestRequestToken = Date.now();
        if (this.state.picUrl && !this.state.keyword) {
            this.setState({ sugId: "" }, () => {
                this.handleSearchKeyword();
            });
            return;
        }
        this.setState({ sugId: "", picUrl: "" }, () => {
            this.handleSearchKeyword();
        });
    };

    handleChange = e => {
        this.setState(
            {
                keyword: e.target.value
            },
            () => {
                this.setState({ searchSuggestions: [] }, () => {
                    this.fetchSearchSuggestions(e.target.value);
                });
            }
        );
    };

    // 处理事件 选择模块
    handleSearchType = resourceType => {
        this.setState(
            {
                searchSourceType: resourceType
            },
            () => {
                const { onSourceTypeChange } = this.props;
                if (onSourceTypeChange) {
                    onSourceTypeChange(resourceType);
                }
            }
        );
    };
    // 选择颜色
    handleSelectColor = color => {
        this.setState({
            selectColor: color
        });
    };

    renderSourceType = () => {
        const { searchSourceTypeList, searchSourceType } = this.state;
        return (
            <Menu
                inlineIndent={8}
                defaultSelectedKeys={[searchSourceType.value]}
                className="global-search-menu"
            >
                {searchSourceTypeList.map(item => (
                    <MenuItem
                        key={item.value}
                        onClick={() => this.handleSearchType(item)}
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </Menu>
        );
    };

    // 保存搜索历史到 localStorage 或其他存储
    saveSearchHistory = () => {
        const { currentSourceTitle, theme } = this.props;
        let searchHistoryKey = "";
        if (theme === "home") {
            searchHistoryKey = "GlobalSearch";
        } else {
            searchHistoryKey =
                SearchHistoryKeys.find(
                    item => item.label === currentSourceTitle
                )?.value || "";
        }
        const historyData = {
            stack: this.history.stack,
            undoStack: this.history.undoStack,
            currentValue: this.history.currentValue
        };
        localStorage.setItem(searchHistoryKey, JSON.stringify(historyData));
    };

    // 从 localStorage 或其他存储加载搜索历史
    loadSearchHistory = () => {
        const { currentSourceTitle, theme } = this.props;
        let searchHistoryKey = "";
        if (theme === "home") {
            searchHistoryKey = "GlobalSearch";
        } else {
            searchHistoryKey =
                SearchHistoryKeys.find(
                    item => item.label === currentSourceTitle
                )?.value || "";
        }
        const historyData = localStorage.getItem(searchHistoryKey);
        return historyData ? JSON.parse(historyData) : null;
    };

    // // 撤销搜索
    // handleUndoSearch = () => {
    //     this.history.undo();
    //     // 撤销操作后更新关键词状态
    //     this.setState({ keyword: this.history.currentValue });
    // }

    // // 重做搜索
    // handleRedoSearch = () => {
    //     this.history.redo();
    //     // 重做操作后更新关键词状态
    //     this.setState({ keyword: this.history.currentValue });
    // }

    handleFocus = e => {
        this.setState({
            searchType: GlobalSearchType.NO_SEARCH,
            searchSuggestions: [] // 清空联想结果
        });
        this.fetchSearchSuggestions(this.state.keyword);
    };

    // 获取联想结果的方法
    fetchSearchSuggestions = async keyword => {
        this.setState({ searchSuggestionsLoading: true });
        const currentTimestamp = Date.now();
        this.latestRequestToken = currentTimestamp;
        const { materialType, theme } = this.props;
        const { searchSourceType, searchHistorys } = this.state;
        const res = await fetchData(urls.search.getSuggest, {
            keyword,
            materialType:
                theme === "home" ? searchSourceType.value : materialType
        });

        if (this.latestRequestToken === currentTimestamp) {
            this.setState({
                searchSuggestions: res || [],
                searchSuggestionsLoading: false,
                isShowSearchSuggestions: Boolean(res?.length) && !!keyword,
                dropdownVisible: !!keyword
                    ? Boolean(res?.length)
                    : searchHistorys?.length > 0
                    ? true
                    : false
            });
            const { sugId } = this.state;
            if (!sugId) {
                this.setState({
                    sugId: generateId()
                });
            }
        } else {
            // 如果不是最新的请求，只需要停止加载状态即可
            console.log("忽略");
        }
    };

    handleSelectKeyword = keyword => {
        this.setState(
            {
                keyword,
                dropdownVisible: false, // 隐藏下拉框
                picUrl: "",
                sugId: ""
            },
            this.handleSearchKeyword
        );
    };
    // 添加删除单条历史记录的方法
    handleDeleteHistoryItem = historyItem => {
        // 从历史记录中删除该项
        this.history.remove(historyItem);
        // 保存到本地存储
        this.saveSearchHistory();
        // 重新初始化历史记录显示
        this.initSearchHistory();
    };
    handleOutsideClick = event => {
        // 确保searchInputRef.current指向DOM元素
        if (
            this.searchDropdownRef.current &&
            !this.searchDropdownRef.current.contains(event.target)
        ) {
            this.setState({ dropdownVisible: false });
        }
    };

    initSearchHistory = () => {
        // 从 localStorage 或其他存储中加载历史记录
        const savedHistory = this.loadSearchHistory();
        if (savedHistory) {
            this.history.stack = savedHistory.stack;
            this.history.undoStack = savedHistory.undoStack;
            this.history.currentValue = savedHistory.currentValue;
        }
        this.setState({ searchHistorys: this.history.stack || [] });
    };

    // 转义正则表达式中的特殊字符
    escapeRegExp = string => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };

    // 高亮匹配关键词
    highlightKeyword = (text, keyword) => {
        // 首先使用 escapeRegExp 函数转义关键词
        const escapedKeyword = this.escapeRegExp(keyword);
        // 然后使用转义后的关键词创建正则表达式
        const parts = text?.split(new RegExp(`(${escapedKeyword})`, "gi"));
        return parts?.map((part, index) =>
            part.toLowerCase() === keyword.toLowerCase() ? (
                <span key={index} className="highlighted-keyword">
                    {part}
                </span>
            ) : (
                part
            )
        );
    };

    clearSearchHistory = () => {
        this.history.clear();
        this.saveSearchHistory();
        this.initSearchHistory();
        this.setState({ dropdownVisible: false });
    };

    handleClickSug = async (keyword, index) => {
        const { materialType } = this.props;

        const { sugId } = this.state;
        this.setState(
            {
                keyword,
                dropdownVisible: false, // 隐藏下拉框
                picUrl: ""
            },
            this.handleSearchKeyword
        );
        if (keyword) {
            const { userMis } = await getUserInfo();
            window.LXAnalytics("set", "uid", userMis);
            const bid = "b_techportal_3zs54c4t_mc";
            window.LXAnalytics(
                "moduleClick",
                bid,
                {
                    source: Resource_Type_Name[materialType],
                    // sessionId,
                    userMis,
                    index,
                    keyword,
                    custom: {
                        sugId
                    }
                },
                { cid: "c_techportal_20l0xjy8" }
            );
        }
    };

    uploadImage = file => {
        this.setState({
            picUrl: file.fileUrl,
            keyword: "",
            searchPicVisible: false
        });
        const { searchSourceType, keyword, sugId } = this.state;
        const param = {
            searchSourceTypeValue: searchSourceType.value,
            keyword,
            sugId,
            picUrl: new URL(file.fileUrl)
        };
        const { handleSearchKeyword } = this.props;
        handleSearchKeyword(param);
    };

    handleClickClosePic = () => {
        this.setState({ picUrl: "" });
    };

    handleClickImgSearch = () => {
        this.latestRequestToken = Date.now();
        this.setState({
            searchType: GlobalSearchType.SEARCH_PIC,
            dropdownVisible: false,
            searchPicVisible: true
        });
    };
    handleRadioChange = selectedValue => {
        console.log("选中的值:", selectedValue);
        this.setState({ selectedRadioValue: selectedValue });
        if (this.props.onSliderChange) {
            this.props.onSliderChange(selectedValue);
        }
    };

    getCanPicSearchVisible = materialType => {
        const { searchSourceType } = this.state;
        const { theme } = this.props;
        const PicArrs = [
            Resource_Type_Identifier.ALL,
            Resource_Type_Identifier.PX_IMAGE,
            Resource_Type_Identifier.MARKET_MATERIAL
        ];
        if (theme === "home") {
            return (
                PicArrs.includes(String(materialType)) &&
                searchSourceType?.canPicSearch
            );
        }
        if (String(materialType) === Resource_Type_Identifier.ALL) {
            return true;
        }
        return false;
    };

    getCartIconCount = () => {
        const iconIdList = getIconsInLs();
        this.setState({
            cartIconCount: iconIdList.size
        });
    };

    render() {
        const {
            searchSourceType,
            keyword,
            searchType,
            selectColor,
            selectPic,
            dropdownVisible,
            searchSuggestions,
            picUrl,
            searchPicVisible,
            isShowSearchSuggestions,
            searchSuggestionsLoading,
            searchHistorys,
            selectedRadioValue,
            showCartDrawer,
            cartIconCount
        } = this.state;
        const {
            theme,
            style,
            currentSourceTitle,
            materialType,
            sliderOptions,
            hasExtraSpace
        } = this.props;
        const PicArrs = [
            Resource_Type_Identifier.ALL,
            Resource_Type_Identifier.PX_IMAGE,
            Resource_Type_Identifier.MARKET_MATERIAL
        ];
        const isSearchPicVisible =
            searchType === GlobalSearchType.SEARCH_PIC && searchPicVisible;

        return (
            <div
                className={classnames("global-search-wrap", {
                    "global-search-wrap-active":
                        dropdownVisible ||
                        searchType === GlobalSearchType.SEARCH_PIC
                })}
                ref={this.searchDropdownRef}
            >
                <div
                    className={classnames(
                        "global-search-operation-wrap",
                        theme === "home"
                            ? "home-search-operation-warp"
                            : "other-search-operation-wrap",
                        searchType !== GlobalSearchType.NO_SEARCH &&
                            (theme === "home"
                                ? "home-search-operation-warp-active"
                                : "other-search-operation-wrap-active")
                    )}
                >
                    <div className="left">
                        <div className="global-search-area-wrap">
                            <Input
                                addonBefore={
                                    picUrl ? (
                                        <div className="search-image-pic">
                                            <Tooltip
                                                className="search-image-pic-tooltip"
                                                message={
                                                    <img
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "cover",
                                                            borderRadius: 2
                                                        }}
                                                        src={picUrl}
                                                    />
                                                }
                                            >
                                                <img src={picUrl} />
                                            </Tooltip>
                                            <Icon
                                                style={{ cursor: "pointer" }}
                                                type="close"
                                                onClick={
                                                    this.handleClickClosePic
                                                }
                                            />
                                        </div>
                                    ) : (
                                        false
                                    )
                                }
                                ref={this.searchInputRef}
                                value={keyword}
                                className="home-search-input"
                                placeholder="Search assets"
                                // onClick={() => this.setState({ searchType: GlobalSearchType.SEARCH_WORD })}
                                clearable={true}
                                onChange={this.handleChange}
                                onPressEnter={this.handlePressEnter}
                                onFocus={this.handleFocus}
                            />
                        </div>
                        <div
                            className={classnames(
                                "search-dropdown",
                                theme === "home"
                                    ? "home-search-dropdown"
                                    : "other-search-dropdown"
                            )}
                            style={{
                                display: dropdownVisible ? "block" : "none"
                                // width: hasExtraSpace
                                //     ? "calc(100% - 48px)"
                                //     : "100%"
                            }}
                        >
                            {isShowSearchSuggestions || !!keyword || (
                                <div className="search-history-global">
                                    <ul className="search-history-container-global">
                                        {searchHistorys.map(
                                            (historyItem, index) => (
                                                <Tooltip message={historyItem}>
                                                    <li
                                                        key={
                                                            historyItem + index
                                                        }
                                                    >
                                                        <Icon
                                                            type="time-o"
                                                            className="mtd-icon-time-o-global"
                                                        />
                                                        <span
                                                            onClick={() =>
                                                                this.handleSelectKeyword(
                                                                    historyItem
                                                                )
                                                            }
                                                        >
                                                            {historyItem}
                                                        </span>
                                                        <Icon
                                                            type="delete-o"
                                                            className="mtd-icon-delete-o-global"
                                                            onClick={e => {
                                                                e.stopPropagation(); // 阻止事件冒泡，防止触发父元素的点击事件
                                                                this.handleDeleteHistoryItem(
                                                                    historyItem
                                                                );
                                                            }}
                                                        />
                                                    </li>
                                                </Tooltip>
                                            )
                                        )}
                                    </ul>
                                </div>
                            )}
                        </div>
                        {/* {
                            theme !== 'home' && <span className='line'></span>
                        } */}
                    </div>
                    <div className="right">
                        <button
                            className="search-button"
                            onClick={this.handlePressEnter}
                        >
                            <img src={SearchIcon} alt="Search" />
                        </button>
                        {/* {
                            searchSourceType.canColorSearch &&
                            <Tooltip message="色彩搜图" autoDestory>
                                {
                                    (selectPic && selectPic.fileCode) ?
                                        <img src={colorIconDisabled} className="search-disabled" /> :
                                        <img ref={this.searchColorRef} src={colorIconNormal} className="search-normal" onClick={() => this.setState({ searchType: GlobalSearchType.SEARCH_COLOR })} />
                                }
                            </Tooltip>
                        } */}
                        {/* {
                            this.getCanPicSearchVisible(materialType) &&
                            <Tooltip message="以图搜图" autoDestory>
                                {
                                    (selectColor && selectColor.color) ?
                                        <img src={picIconDisabled} className="search-disabled" /> :
                                        <img ref={this.searchPicRef} src={picIconNormal} className="search-normal" onClick={this.handleClickImgSearch} />
                                }
                            </Tooltip>
                        } */}
                    </div>
                </div>
            </div>
        );
    }
}
